import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export type CarouselPropsType = { items : JSX.Element[], settings : Settings}

export default function Carousel({ items = [], settings } : CarouselPropsType) {
  return <Slider {...settings}>{items.map((item, index) => item)}</Slider>;
}
